import script from "./PaymentMethodAndCreditsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentMethodAndCreditsTab.vue?vue&type=script&setup=true&lang=js"

import "./PaymentMethodAndCreditsTab.vue?vue&type=style&index=0&id=8e0f211e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e0f211e"]])

export default __exports__